import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da90832"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-frame"]
const _hoisted_2 = {
  key: 0,
  class: "hd-mod-timeline-frames__frame-debug"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Width: "),
  /*#__PURE__*/_createElementVNode("span", { class: "js-timeline-width-debug-width" }, "100%")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Height: "),
  /*#__PURE__*/_createElementVNode("span", { class: "js-timeline-width-debug-height" }, "100%")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-mod-timeline-frames',
			{ 'is-ready': _ctx.ready }
		])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datum, (frame) => {
      return (_openBlock(), _createElementBlock("div", {
        key: frame.endpointId,
        class: "hd-mod-timeline-frames__frame js-mod-timeline-frame js-timeline-container-3",
        "data-frame": frame.endpointId
      }, [
        (frame && frame.endpointId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(frame.endpointId), 1),
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    }), 128))
  ], 2))
}